import { get } from "lodash";

const edroneFrameId = "unlayer-edrone-frame";

const renderUnsubscribe = (contentWidth) => `
    <!-- Start Unsubscribe In Footer -->
    <!--[if (mso)|(IE)]>
      <td align="center" width="${contentWidth / 2}"
          style="width: ${
            contentWidth / 2
          }px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px;-webkit-border-radius: 0px; -moz-border-radius: 0px;"
          valign="top"><![endif]-->
      <div class="u-col u-col-50" style="max-width: 320px;min-width: ${
        contentWidth / 2
      }px;display: table-cell;vertical-align: top;">
        <div style="height: 100%;width: 100% !important;border-radius: 0px;-webkit-border-radius: 0px; -moz-border-radius: 0px;">
          <!--[if (!mso)&(!IE)]><!-->
          <div
            style="box-sizing: border-box; height: 100%; padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px;-webkit-border-radius: 0px; -moz-border-radius: 0px;">
            <!--<![endif]-->

            <table style="font-family:arial,helvetica,sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0">
              <tbody>
              <tr>
                <td class="v-container-padding-padding"
                    style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif;" align="left">

                  <div class="v-text-align v-font-size" style="font-size: 14px; line-height: 140%; text-align: right; word-wrap: break-word;">
                    <p style="line-height: 140%; margin: 0px;"><a style="text-decoration: none; color: #A3A3A3 !important;" href="*|UNSUBSCRIBE_LINK|*">*|FRAME_UNSUBSCRIBE_TEXT|*</a></p>
                  </div>

                </td>
              </tr>
              </tbody>
            </table>

            <!--[if (!mso)&(!IE)]><!--></div><!--<![endif]-->
        </div>
      </div>
      <!--[if (mso)|(IE)]></td><![endif]-->
    <!-- End Unsubscribe In Footer -->
`;

const renderPoweredByEdrone = (contentWidth) => `
    <!-- Start Edrone Logo In Footer -->
      <!--[if (mso)|(IE)]>
      <td align="center" width="${contentWidth / 2}"
          style="width: ${
            contentWidth / 2
          }px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px;-webkit-border-radius: 0px; -moz-border-radius: 0px;"
          valign="top"><![endif]-->
      <div class="u-col u-col-50" style="max-width: 320px;min-width: ${
        contentWidth / 2
      }px;display: table-cell;vertical-align: top;">
        <div style="height: 100%;width: 100% !important;border-radius: 0px;-webkit-border-radius: 0px; -moz-border-radius: 0px;">
          <!--[if (!mso)&(!IE)]><!-->
          <div
            style="box-sizing: border-box; height: 100%; padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px;-webkit-border-radius: 0px; -moz-border-radius: 0px;">
            <!--<![endif]-->

            <table style="font-family:arial,helvetica,sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0">
              <tbody>
              <tr>
                <td class="v-container-padding-padding"
                    style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif;" align="left">

                  <div class="v-text-align v-font-size" style="font-size: 14px; line-height: 140%; text-align: left; word-wrap: break-word;">
                    <p style="line-height: 140%; margin: 0 !important;"><a style="text-decoration: none; color: #A3A3A3 !important;" href="https://www.edrone.me"><img alt="Powered by edrone" align="left" hspace="22" width="15" height="17" class="logo power-logo" src="https://d3vhsxl1pwzf0p.cloudfront.net/images/emailtemplate/footer_logo.png" style="outline: none; text-decoration: none; -ms-interpolation-mode: bicubic; width: 20px; max-width: 20px !important; float: left; clear: both; display: block; margin: 0 5px 0 !important;"> powered by edrone.me</a></p>
                  </div>

                </td>
              </tr>
              </tbody>
            </table>

            <!--[if (!mso)&(!IE)]><!--></div><!--<![endif]-->
        </div>
      </div>
      <!--[if (mso)|(IE)]></td><![endif]-->
    <!-- End Edrone Logo In Footer -->
`;

const renderPixel = () => `
    <!-- FRAME_OPEN_TRACKING_GMAIL -->
`;

const renderFooter = (contentWidth) => `
<!-- Start Edrone Footer -->
<div id="${edroneFrameId}" data-id="EDRONE_NEW_FOOTER" class="u-row-footer--edrone u-row-container v-row-padding--vertical" style="padding: 0px;background-color: transparent">
  <!-- FRAME_OPEN_TRACKING_OTHER -->
  <div class="u-row"
       style="margin: 0 auto;min-width: 320px;max-width: 720px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: transparent;">
    <div style="border-collapse: collapse;display: table;width: 100%;height: 100%;background-color: transparent;">
      <!--[if (mso)|(IE)]>
      <table width="100%" cellpadding="0" cellspacing="0" border="0">
        <tr>
          <td style="padding: 0px;background-color: transparent;" align="center">
            <table cellpadding="0" cellspacing="0" border="0" style="width:720px;">
              <tr style="background-color: transparent;"><![endif]-->
${renderPoweredByEdrone(contentWidth)}
${renderUnsubscribe(contentWidth)}
      <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]-->
    </div>
  </div>
  <span style="display: none !important;mso-hide:all;" data-meta="*|METADATA_JSON|*"></span>
</div>
<!-- End Edrone Footer -->
`;

export function withEdroneFooter(html, design) {
  if (html.includes(edroneFrameId)) {
    return html;
  }

  try {
    const widthPx = get(design, "body.values.contentWidth", "720px");
    const contentWidth = parseInt(widthPx);

    const footer = renderFooter(contentWidth);
    const pixel = renderPixel();

    const bodyTags = html.match(/<body[^>]*>/g);
    if (!bodyTags || bodyTags.length < 2) {
      html = html.replace("</body>", `${footer}</body>`);
      const parts = html.split(bodyTags[0]);
      return parts[0] + bodyTags[0] + pixel + parts[1];
    }

    const lastBodyIndex = html.lastIndexOf("</body>");
    const beforeLastBody = html.substring(0, lastBodyIndex);
    const afterLastBody = html.substring(lastBodyIndex);

    html = beforeLastBody + footer + afterLastBody;

    const firstBodyIndex = html.indexOf(bodyTags[0]) + bodyTags[0].length;
    html = html.substring(0, firstBodyIndex) + pixel + html.substring(firstBodyIndex);
    return html;
  } catch (e) {
    return html;
  }
}
